import {Toggle} from "./Toggle";
import {Utils} from "./Utils";

export interface DropdownMenuConfig {
    triggers: NodeListOf<HTMLElement>;
    target: HTMLElement;
    frame: HTMLElement;
    container: HTMLElement;
}

export class DropdownMenu extends Toggle {
    protected readonly frame: HTMLElement;
    protected readonly container: HTMLElement;

    constructor(options: DropdownMenuConfig) {
        super(options);
        this.frame = options.frame;
        this.container = options.container;
        this.bind()
    }

    public close(evt: Event): void {
        const
            tags = [`A`, `BUTTON`, `P`, `SPAN`, `svg`, `path`],
            target = evt.target as HTMLElement;
        if (tags.includes(target.tagName)) return;
        this.toggle(evt);
    }

    public toggle(evt: Event): void {
        Utils.toggleScroll();
        this.container.classList.toggle(`is-opened`);
        super.toggle(evt);
    }

    protected bind() {
        if (this.frame) this.frame.addEventListener( 'click', (evt) => this.close(evt));
    }
}